import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import theme from '../constants/theme'
import {
  FooterContent,
  MainContainer,
  NotificationBox,
} from '../components/styled'
import CheckOne from '../assets/svgs/checkOne'
import CalendarSquare from '../assets/svgs/calendarSquare'
import Clock from '../assets/svgs/clock'
import useDeviceType from '../hooks/useDeviceType'

function ScheduledNotification() {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const deviceType = useDeviceType()
  const isMobile = deviceType !== 'desktop'

  const [scheduledDate, setScheduledDate] = useState(null)
  const [scheduledTime, setScheduledTime] = useState(null)
  const [additionalDetails, setAdditionalDetails] = useState(null)

  useEffect(() => {
    // Get data from navigation state
    if (location.state) {
      setScheduledDate(location.state.scheduledDate)
      setScheduledTime(location.state.scheduledTime)
      setAdditionalDetails(location.state.additionalDetails)
    } else {
      // If no state, redirect to home or show error
      // navigate('/')
    }
  }, [location, navigate])

  const InfoBox = ({ icon, children }) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: isMobile ? '8px' : '12px',
        padding: isMobile ? '10px 12px' : '12px 16px',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        marginTop: isMobile ? '8px' : '12px',
        width: '100%',
        justifyContent: 'flex-start',
      }}
    >
      <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
        {icon}
      </div>
      <div
        style={{
          fontSize: isMobile ? '13px' : '14px',
          color: '#2c3e50',
          fontWeight: '500',
          textAlign: 'left',
          flex: 1,
        }}
      >
        {children}
      </div>
    </div>
  )

  InfoBox.propTypes = {
    icon: PropTypes.node,
    children: PropTypes.node,
  }

  return (
    <MainContainer backgroundColor={theme.talentinoSkyBlue}>
      <div
        className="d-flex flex-column justify-content-center align-items-center w-100 h-100 p-3"
        style={{ flexGrow: 1 }}
      >
        <NotificationBox
          color={theme.talentinoGreen}
          minWidth={isMobile ? '90%' : undefined}
          style={{
            padding: isMobile ? '25px 15px' : '40px',
            maxWidth: isMobile ? '95%' : undefined,
          }}
        >
          <CheckOne
            width={isMobile ? '36px' : '48px'}
            height={isMobile ? '36px' : '48px'}
          />

          <p
            style={{
              fontSize: isMobile ? '18px' : '20px',
              textAlign: 'center',
              marginBottom: '0',
              maxWidth: isMobile ? '280px' : '500px',
              margin: '0 auto',
            }}
          >
            {t('calendar.interviewBookedSuccess')}
          </p>

          {(scheduledDate || scheduledTime || additionalDetails) && (
            <div
              style={{
                width: '100%',
                maxWidth: isMobile ? '300px' : '400px',
                marginTop: '16px',
              }}
            >
              {scheduledDate && (
                <InfoBox
                  icon={
                    <CalendarSquare
                      width={isMobile ? '18px' : '20px'}
                      height={isMobile ? '18px' : '20px'}
                      color={theme.talentinoGreen}
                    />
                  }
                >
                  {scheduledDate}
                </InfoBox>
              )}

              {scheduledTime && (
                <InfoBox
                  icon={
                    <Clock
                      width={isMobile ? '18px' : '20px'}
                      height={isMobile ? '18px' : '20px'}
                      color={theme.talentinoGreen}
                    />
                  }
                >
                  {scheduledTime}
                </InfoBox>
              )}

              {additionalDetails && (
                <div
                  style={{
                    padding: isMobile ? '10px 12px' : '12px 16px',
                    backgroundColor: '#e8f5e9',
                    borderRadius: '8px',
                    marginTop: isMobile ? '8px' : '12px',
                    borderLeft: `3px solid ${theme.talentinoGreen}`,
                  }}
                >
                  <div
                    style={{
                      fontSize: isMobile ? '11px' : '12px',
                      color: '#666',
                      fontWeight: '600',
                      marginBottom: '4px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                    }}
                  >
                    {t('calendar.additionalDetails')}
                  </div>
                  <div
                    style={{
                      fontSize: isMobile ? '12px' : '13px',
                      color: '#2c3e50',
                      lineHeight: '1.5',
                      textAlign: 'left',
                    }}
                  >
                    {additionalDetails}
                  </div>
                </div>
              )}
            </div>
          )}
        </NotificationBox>

        <div
          className="fixed-bottom"
          style={{
            marginLeft: isMobile ? '10px' : '30px',
            marginBottom: isMobile ? '10px' : '30px',
            display: 'inline-flex',
            padding: isMobile ? '10px' : '15px',
          }}
        >
          <p
            style={{
              color: theme.talentinoDarkerGray,
              fontSize: isMobile ? '11px' : '13px',
              fontWeight: '400',
            }}
          >
            <span style={{ fontWeight: '600' }}>
              {' '}
              {t('footer.TalentinoAI')}{' '}
              <FooterContent>© {new Date().getFullYear()}</FooterContent>
            </span>
            .{' '}
            <span style={{ fontWeight: '600' }}>
              {t('footer.allRightsReserved')}
            </span>
          </p>
        </div>
      </div>
    </MainContainer>
  )
}

export default ScheduledNotification
